import { render, staticRenderFns } from "./FourthPage.vue?vue&type=template&id=13a0437c&scoped=true&"
import script from "./FourthPage.vue?vue&type=script&lang=js&"
export * from "./FourthPage.vue?vue&type=script&lang=js&"
import style0 from "./FourthPage.vue?vue&type=style&index=0&id=13a0437c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13a0437c",
  null
  
)

export default component.exports